(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Set custom breakpoint for accordions in the footer (1100px instead of default 750px)
  // This runs after DOMContentLoaded, so we need to force the accordion to reinitialize
  document
    .querySelectorAll('.footer-content accordion-custom[data-disable-on-desktop="true"]')
    .forEach((accordion) => {
      accordion.dataset.breakpoint = '1100';
      // Force reinitialization by reconnecting the element to the DOM
      const parent = accordion.parentNode;
      const nextSibling = accordion.nextSibling;
      parent.removeChild(accordion);
      parent.insertBefore(accordion, nextSibling);
    });

  } catch(e) { console.error(e); }
})();
})();
